import type {TicketTagDescriptionState} from './types';

import {getTagDescription, getTags, getTicket, getTickets, newTicket} from './thunk';

export const ticketBuilder = (builder: any) => {
  builder
    .addCase(
      getTagDescription.pending,
      (
        state: {tagDescription: TicketTagDescriptionState},
        action: ReturnType<typeof getTagDescription.pending>
      ) => {
        state.tagDescription = {
          tagId: action.meta.arg.tag_id,
          vendorId: action.meta.arg.vendor_id,
          requestId: action.meta.requestId,
          html: null,
          loading: true,
          error: false
        };
      }
    )
    .addCase(
      getTagDescription.fulfilled,
      (
        state: {tagDescription: TicketTagDescriptionState},
        action: ReturnType<typeof getTagDescription.fulfilled>
      ) => {
        if (state.tagDescription.requestId !== action.meta.requestId) return;
        state.tagDescription.html = action.payload.data?.description ?? null;
        state.tagDescription.loading = false;
      }
    )
    .addCase(
      getTagDescription.rejected,
      (
        state: {tagDescription: TicketTagDescriptionState},
        action: ReturnType<typeof getTagDescription.rejected>
      ) => {
        if (state.tagDescription.requestId !== action.meta.requestId) return;
        state.tagDescription.loading = false;
        state.tagDescription.error = !action.meta.aborted;
      }
    );

  builder
    .addCase(getTickets.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getTickets.fulfilled, (state: any, action: any) => {
      const data = action.payload.data;
      const page = action.meta?.arg?.page ?? 1;
      if (page > 1 && state.tickets?.tickets?.length) {
        state.tickets = {
          ...data,
          tickets: [...state.tickets.tickets, ...(data?.tickets ?? [])]
        };
      } else {
        state.tickets = data;
      }
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getTickets.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getTicket.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getTicket.fulfilled, (state: any, action: any) => {
      state.ticket = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getTicket.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getTags.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getTags.fulfilled, (state: any, action: any) => {
      state.tags = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getTags.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(newTicket.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(newTicket.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(newTicket.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
